import React from "react";
import { Link } from "react-router-dom";
import FolkDivider from "@/components/FolkDivider";
import { useT } from "@/i18n/useT";

export default function StoryPage() {
  const t = useT();
  const s = t.story;
  return (
    <div data-testid="story-page" className="bg-cream">
      <section className="relative h-[70vh] min-h-[480px] overflow-hidden">
        <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: "url(https://images.pexels.com/photos/8003036/pexels-photo-8003036.jpeg?w=2000&q=80)" }} />
        <div className="absolute inset-0 bg-espresso/30" />
        <div className="relative h-full br-container flex items-end pb-20">
          <div className="text-cream max-w-3xl br-fade-in">
            <div className="text-[11px] uppercase tracking-[0.4em] text-amber mb-6">{s.eyebrow}</div>
            <h1 className="font-serif text-5xl md:text-7xl leading-[1.05] text-cream">{s.heroTitle}</h1>
          </div>
        </div>
      </section>
      <section className="br-container py-24 md:py-32 max-w-3xl">
        <article className="space-y-8 text-lg font-light text-dark-walnut leading-[1.85] br-fade-in">
          <p className="first-letter:font-serif first-letter:text-7xl first-letter:float-left first-letter:mr-3 first-letter:leading-[0.85] first-letter:text-walnut">{s.p1}</p>
          <p>{s.p2}</p><p>{s.p3}</p><p>{s.p4}</p>
          <p className="font-serif italic text-2xl text-espresso pt-6">{s.closing}</p>
        </article>
      </section>
      <FolkDivider />
      <section className="br-container pb-32">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-16 max-w-5xl mx-auto">
          {[s.values.slowLiving, s.values.craft, s.values.amber, s.values.linen].map((v) => (
            <div key={v.eyebrow} className="br-fade-in">
              <div className="br-eyebrow mb-3">{v.eyebrow}</div>
              <h3 className="font-serif text-2xl text-espresso mb-3">{v.title}</h3>
              <p className="text-base font-light text-dark-walnut leading-relaxed">{v.body}</p>
            </div>
          ))}
        </div>
      </section>
      <section className="bg-walnut/5 py-24 text-center">
        <div className="br-container max-w-xl">
          <h2 className="font-serif text-3xl md:text-4xl text-espresso">{s.ctaTitle}</h2>
          <div className="mt-8"><Link to="/shop" className="br-btn-outline">{s.ctaBtn}</Link></div>
        </div>
      </section>
    </div>
  );
}